import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SyncAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sync_alt"}/>
}
